// SVG paths and stroke sizes from Plant Factory Direct's Essence theme.
export default function EssenceIcon({ name, className = '' }) {
  const paths = name === 'menu' ? ['M21 16L3 16', 'M21 8L3 8']
    : name === 'close' ? ['M5 19L19 5', 'M5 5L19 19']
      : ['M8.00003 20L16 12L8.00003 4.00004']
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="square" strokeLinejoin="miter" aria-hidden="true" className={className}>
    {paths.map(d => <path key={d} d={d} vectorEffect="non-scaling-stroke" />)}
  </svg>
}
